import { Icon, Menu, MenuItem, Popover } from '@blueprintjs/core';
import { Dispatch, SetStateAction } from 'react';
import classes from './AceDropdown.module.css';

export function AceDropdown<TValue>({
  label,
  options,
  value,
  setValue,
}: {
  label: string;
  options: { label: string; value: TValue }[];
  value: TValue;
  setValue: Dispatch<SetStateAction<TValue>>;
}) {
  return (
    <span>
      <strong>{label}:</strong>{' '}
      <Popover
        interactionKind="hover"
        placement="bottom"
        content={
          <Menu>
            {options.map((option) => (
              <MenuItem
                key={`Filter-${option.value}`}
                text={option.label}
                selected={option.value === value}
                onClick={() => setValue(option.value)}
              />
            ))}
          </Menu>
        }
      >
        <span role="button" className={classes.target}>
          <span className={classes.value}>
            {options.find((x) => x.value === value)?.label}{' '}
          </span>
          <Icon icon="chevron-down" intent="primary" />
        </span>
      </Popover>
    </span>
  );
}
